import React, {Component} from 'react';

class StatusBox extends Component {
    render() {
        return (
            <div className="status-tab">
                <div className="status-header">
                    <span className="col-first">Severity</span>
                    <span className="col-second">Message</span>
                </div>
                <div className="success-status">
                    <span className="col-first">Success</span>
                    <span className="col-second">No Errors were found.</span>
                </div>
            </div>
        )
    }
}
export default StatusBox;